import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Table, TableColumn } from '../../Zemplin/General/Table';
import { ProductTabRowTable } from '../Product/ProductTabRowTable';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from '../../Zemplin/General/NoItemsWrapper';

export interface Props {
  columns: Array<{ name: string; align?: string }>;
  rows: any[];
  noItemsText?: string;
}

function TableWrapper({
  columns,
  rows,
  noItemsText = __('Nenašli sa žiadne výsledky'),
}: Props) {
  return (
    <>
      {!rows || rows.length === 0 ? (
        <NoItemsWrapper height={300} text={noItemsText} />
      ) : (
        <StyledTable>
          <thead>
            {columns.map(item => (
              <TableTh align={item.align || 'left'} key={item.name}>
                {item.name}
              </TableTh>
            ))}
          </thead>
          <tbody>{rows}</tbody>
        </StyledTable>
      )}
    </>
  );
}

const TableTh: any = styled.th`
  text-align: ${(props: TableColumn) => props.align || 'left'};
  padding: 0 0 ${rem(16)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  font-weight: 700;
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StyledTable = styled(Table)`
  margin-bottom: ${rem(20)};
`;

export { TableWrapper };
